import React from "react";
import Render from "@gqlapp/theme";
import template from "./view.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import HtmlContent from "@lib/components/HtmlContent";
import { safeQuery, fetchMenu } from "@lib/content/fetch";
import { cleanPath } from "@lib/content/normalize";
import ARTICLE_QUERY from "@modules/article/graphql/ArticleQuery.graphql";

const EMPTY = { found: false, title: '', body: '', categories: [] };

export default function ViewContainer(props: any){
	const { articleData } = props;
	return <>
		<Render {...{ template, context: { partials: { ...sharedPartials }, HtmlContent, ...EMPTY, ...(articleData || {}) } }} />
	</>;
}

ViewContainer.getInitialProps = async (ctx: any) => {
	const { apolloClient } = ctx || {};
	const path = cleanPath(ctx?.path);

	try {
		const [data, categories] = await Promise.all([
			safeQuery(apolloClient, ARTICLE_QUERY, { path }),
			fetchMenu(apolloClient, 'article'),
		]);
		const res = data?.res;
		const body = typeof res?.body === 'string' ? res.body : (res?.body?.processed || res?.body?.value || '');
		return { articleData: { found: !!res, title: res?.title || ctx?.graphqlRoute?.title || '', body, categories } };
	} catch (e) {
		debug(e);
		return { articleData: { ...EMPTY, title: ctx?.graphqlRoute?.title || '' } };
	}
};
